import { Link, NumberedMilestones, Text, TextContainer } from "@wayflyer/flyui";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { MESSAGES } from "./message-definitions";

const getConnectionsPageUrl = (customerDomain: string, connectionsPageV2Enabled: boolean): string => {
  return connectionsPageV2Enabled
    ? `/${customerDomain}/settings/company/connections`
    : `/${customerDomain}/settings/connections`;
};

export const HowItWorks = () => {
  const intl = useIntl();

  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const connectionsPageV2Enabled = useFeatureFlagEnabled("connections_page_v2") ?? false;

  return (
    <NumberedMilestones
      milestones={[
        {
          number: "01",
          title: intl.formatMessage(MESSAGES.faqSubmitNewFundingApplicationHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqSubmitNewFundingApplicationBody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
              })}
            </TextContainer>
          ),
        },
        {
          number: "02",
          title: intl.formatMessage(MESSAGES.faqReviewDataHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqReviewDatabody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
                x: (chunks: any) => (
                  <Link url={getConnectionsPageUrl(customerDomain, connectionsPageV2Enabled)}>{chunks}</Link>
                ),
              })}
            </TextContainer>
          ),
        },
        {
          number: "03",
          title: intl.formatMessage(MESSAGES.faqReviewAndSelectOffersHeader),
          body: <TextContainer>{intl.formatMessage(MESSAGES.faqReviewAndSelectOffersBody)}</TextContainer>,
        },
        {
          number: "04",
          title: intl.formatMessage(MESSAGES.faqAcceptContractReceiveFundingHeader),
          body: (
            <TextContainer>
              {intl.formatMessage(MESSAGES.faqAcceptContractReceiveFundingBody, {
                p: (chunks: any) => <Text>{chunks}</Text>,
              })}
            </TextContainer>
          ),
        },
      ]}
    />
  );
};
